import React, { useState } from "react";
import { getApiUrl } from "../../lib/api";

const ClearBatchButton = ({ batchId, onSuccess }) => {
  const [isClearing, setIsClearing] = useState(false);

  const handleClick = async () => {
    if (!batchId) return;
    setIsClearing(true);

    try {
      const res = await fetch(getApiUrl("/api/delete-supabase-batch"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ batchId }),
      });

      const data = await res.json();

      if (!res.ok) {
        console.error("Clear batch failed:", data);
        return;
      }

      console.log(`[ClearBatchButton] Deleted ${data.deleted} files.`);
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error("Error clearing batch:", err);
    } finally {
      setIsClearing(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={isClearing}
      className={`px-5 py-2 rounded-lg shadow-md text-white transition font-semibold ${
        isClearing ? "bg-zinc-500 cursor-wait" : "bg-zinc-700 hover:bg-zinc-600"
      }`}
    >
      {isClearing ? "Clearing…" : "Clear Batch"}
    </button>
  );
};

export default ClearBatchButton;
